import { useEffect, memo, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Row, Col, Select, Modal, Input } from "antd";
import styled from "styled-components";
import moment from "moment";
import {
  IAmphur,
  IResultUpdate,
  ITrashfeeArea,
  ITrashfeeAreaCreate,
  ITrashfeeDistrict,
  ITrashfeeHouse,
  ITrashfeeHouseCreate,
  ITrashfeeHouseUpdate,
} from "@interfaces";
import { StyledSubmitButton, StyledCancelButton, StyledCard, SharedInput } from "@components";
import { useYup } from "@validations";
import { setLoading, selectAuth, selectContact } from "@redux";
import { showErrorMessage, useNotify } from "@utils";
import { PATH_TRASH_FEE_BUSINESS, PATH_TRASH_FEE_BUSINESS_CREATE, PATH_TRASH_FEE_HOUSE, PATH_TRASH_FEE_HOUSE_CREATE } from "@configs";
import { trashfeeAPI } from "@api";

interface IProps {
  // result: IResult | undefined;
  detail: ITrashfeeHouse | undefined;
  areaList: ITrashfeeArea[];
}

const initData: IResultUpdate = {
  organization_id: "",
  title: "",
  image_url: "",
  is_enable: true,
  information_id: "",
  created_date: new Date().toString(),
  documents: [],
};
const { Option } = Select;
export const ModuleBusinessForm = memo((props: IProps) => {
  //hook
  const { YupNews, YupBidding } = useYup();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { error, success } = useNotify();
  const search_params = useSelector(selectContact).paramsContact;
  const org_id = useSelector(selectAuth).auth?.organization_data?._id;
  const [districtList, setDistrictList] = useState<ITrashfeeDistrict[]>([]);

  const organization_id = useSelector(selectAuth).auth?.admin_data?.organization_id;

  const pathName = window.location.pathname;

  const createBidding = Yup.object().shape(YupBidding);
  const { detail, areaList } = props;
  const [amphurList, setAmphurList] = useState<IAmphur[]>([]);
  const [focusAmphur, setFocusAmphur] = useState<string>("");
  const prefix = ['คุณ', 'นาย', 'นาง', 'นางสาว'];
  const [value, setValue] = useState({
    organization_id: "",
    profile_id: "",
    area_id: "",
    register_no: "",
    prefix: "",
    name: "",
    surname: "",
    card_no: "",
    house_no: "",
    amphur_id: "",
    moo: "",
    soi: "",
    road: "",
    district_id: "",
    house_type: "business",
    trash_fee: 0,
  });


  useEffect(() => {
    if (org_id) {
      getAllAmphur();
    }
  }, [org_id]);

  useEffect(() => {
    if (focusAmphur !== "") {
      fetchDistrict(focusAmphur);
    }
  }, [focusAmphur]);

  useEffect(() => {
    if (detail) {
      console.log('detail', detail);
      setValue({
        ...value,
        area_id: detail.area_id,
        register_no: detail.register_no,
        prefix: detail.owner.prefix,
        name: detail.owner.name,
        surname: detail.owner.surname,
        card_no: detail.owner.card_no,
        house_no: detail.house_no,
        moo: detail.moo,
        soi: detail.soi,
        road: detail.road,
        district_id: detail.district_id,
        trash_fee: detail.trash_fee,
        amphur_id: detail?.amphur_id,
        ...(detail.amphur_id === "" && {
          district_id: "",
          amphur_id: "",
        }),
      });
      setFocusAmphur(detail?.amphur_id);
      // setFieldValue("title", result.title);
      // setFieldValue("is_enable", result.is_enable);
      // setFieldValue("information_id", result._id);
      // setFieldValue("created_date", result.created_date);
      // setFieldValue("documents", result.documents);
      // setFieldValue("image_url", result.image_url);
    }
  }, [detail]);

  const handleBiddingSubmit = (values: IResultUpdate) => {
    // console.log("hello submit", values);
  };

  const handleClose = () => {
    history.push(PATH_TRASH_FEE_BUSINESS);
  };

  const prefixChange = (text: string) => {
    setValue({
      ...value,
      prefix: text,
    });
  };

  const getAllAmphur = async () => {
    try {
      let response = await trashfeeAPI.getAllAmphurByOrganizationId({
        organization_id: org_id || ""
      });
      if (response.data.error === "0") {
        setAmphurList(response.data.result);
      } else {
        error(response.data.msg);
      }
    } catch (error: any) {
      if (error) {
        error(error.msg);
      }
    }
  };

  const fetchDistrict = async (aId: string) => {
    try {
      const response = await trashfeeAPI.getDistrictList({
        amphur_id: aId,
        xpage: 1,
        xlimit: 30,
      });
      setDistrictList(response.data.result);
    } catch (err: any) {
      error(err.message);
    }
  };

  const districtChange = (id: string) => {
    setValue({
      ...value,
      district_id: id,
    });
  };
  const areaChange = (id: string) => {
    setValue({
      ...value,
      area_id: id,
    });
  };
  const amphurChange = (id: string) => {
    setValue({
      ...value,
      amphur_id: id,
      district_id: "",
    });
    setFocusAmphur(id);
  };

  const { values, handleChange, handleBlur, handleSubmit, errors, touched, setFieldValue } =
    useFormik({
      initialValues: initData,
      validationSchema: createBidding,
      enableReinitialize: true,
      onSubmit: handleBiddingSubmit,
    });

  const saveHouse = async () => {
    // save house
    if (pathName === PATH_TRASH_FEE_BUSINESS_CREATE) {
      try {
        let payload: ITrashfeeHouseCreate = {
          organization_id: organization_id || "",
          profile_id: "",
          area_id: value.area_id,
          register_no: value.register_no,
          prefix: value.prefix,
          name: value.name,
          surname: value.surname,
          card_no: value.card_no,
          house_no: value.house_no,
          moo: value.moo,
          soi: value.soi,
          road: value.road,
          district_id: value.district_id,
          house_type: "business",
          trash_fee: value.trash_fee,
          amphur_id: value.amphur_id,
        };
        const response = await trashfeeAPI.createHouse(payload);
        if (response.data.error === "0") {
          success(t("message.create.success"));
          handleClose();
        } else {
          error(response.data.msg);
        }

      } catch (err: any) {
        if (err.response) {
          err(showErrorMessage(err.response));
        } else {
          error(t("message.error"));
        }
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const editHouse = async () => {
    // save house
    if (id !== "") {
      console.log(typeof (value.trash_fee));
      try {
        let payload: ITrashfeeHouseUpdate = {
          organization_id: organization_id || "",
          house_id: id,
          profile_id: "",
          area_id: value.area_id,
          register_no: value.register_no,
          prefix: value.prefix,
          name: value.name,
          surname: value.surname,
          card_no: value.card_no,
          house_no: value.house_no,
          moo: value.moo,
          soi: value.soi,
          road: value.road,
          district_id: value.district_id,
          house_type: "business",
          trash_fee: value.trash_fee,
          amphur_id: value.amphur_id,
        };
        const response = await trashfeeAPI.updateHouse(payload);
        if (response.data.error === "0") {
          success(t("message.create.success"));
          handleClose();
        } else {
          error(response.data.msg);
        }

      } catch (err: any) {
        if (err.response) {
          err(showErrorMessage(err.response));
        } else {
          error(t("message.error"));
        }
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const saveArea = () => {
    dispatch(setLoading(true));
    try {
      // const payload: ITrashfeeAreaCreate = {
      //   organization_id: organization_id || "",
      //   area_name: 
      // }
    } catch {

    }
  };

  const changeField = (e: any) => {
    let arr = value;
    arr[e.target.id] = e.target.value;
    setValue({ ...arr });
  };

  const changeTrashfee = (e: any) => {
    let price = parseInt(e.target.value);
    if (e.target.value === "") {
      price = 0;
    }
    console.log(price);
    let arr = value;
    arr[e.target.id] = price;
    setValue({ ...arr });
  };

  return (
    <div className="form-wrap">
      <form onSubmit={handleSubmit}>
        <div className="page-header">
          <h3>
            {pathName === PATH_TRASH_FEE_BUSINESS_CREATE
              ? "เพิ่มรายชื่อทะเบียนประเภทกิจการ"
              : "แก้ไขรายชื่อทะเบียนประเภทกิจการ"
            }
          </h3>
          <p>โปรดระบุรายละเอียดให้ครบถ้วน</p>
        </div>
        {/* สร้างรายการประกาศผล */}
        {pathName === PATH_TRASH_FEE_BUSINESS_CREATE ? (
          <StyledPageBody>
            <StyledCard>
              <div className="title">
                ข้อมูลเจ้าของทะเบียนบ้านกิจการ
              </div>
              <div>
                <Row gutter={16}>
                  <Col md={12}>
                    <SharedInput
                      label="เลขที่นิติบุคคล*"
                      // descLabel={t("page._2_100_characters")}
                      name="card_no"
                      value={value.card_no}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="ชื่อกิจการ*"
                      // descLabel={t("page._2_100_characters")}
                      name="name"
                      value={value.name}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>

                </Row>
              </div>
            </StyledCard>
            <StyledCard>
              <div className="title">
                ข้อมูลที่อยู่
              </div>
              <div>
                <Row gutter={16}>
                  <Col md={12}>
                    <label className="label">
                      <span className="label-name">หมวดพื้นที่*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value.area_id}
                      onChange={areaChange}
                    >
                      {areaList.length > 0 &&
                        areaList.map((item, index) => {
                          return (
                            <Option value={item._id} key={index}>
                              {item.area_name}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="เลขที่ทะเบียนบ้าน*"
                      // descLabel={t("page._2_100_characters")}
                      name="register_no"
                      value={value.register_no}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="บ้านเลขที่*"
                      // descLabel={t("page._2_100_characters")}
                      name="house_no"
                      value={value.house_no}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="ซอย"
                      // descLabel={t("page._2_100_characters")}
                      name="soi"
                      value={value.soi}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="หมู่"
                      // descLabel={t("page._2_100_characters")}
                      name="moo"
                      value={value.moo}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="ถนน"
                      // descLabel={t("page._2_100_characters")}
                      name="road"
                      value={value.road}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <label className="label">
                      <span className="label-name">อำเภอ*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value?.amphur_id}
                      onChange={amphurChange}
                    >
                      {amphurList.length > 0 &&
                        amphurList.map((item, index) => {
                          return (
                            <Option value={item.amphur_id} key={index}>
                              {item.amphur_name_tha}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  <Col md={12}>
                    <label className="label">
                      <span className="label-name">ตำบล*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value.district_id}
                      onChange={districtChange}
                    >
                      {districtList.length > 0 &&
                        districtList.map((item, index) => {
                          return (
                            <Option value={item.district_id} key={index}>
                              {item.district_name_tha}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  {/* <Col md={12}>
                    <SharedInput
                      label="รหัสไปรษณีย์"
                      // descLabel={t("page._2_100_characters")}
                      name="card_no"
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col> */}
                </Row>
              </div>

            </StyledCard>
            <StyledCard>
              <div className="title">
                จำนวนค่าขยะทั้งหมด
              </div>
              <StyledFee>
                <Row gutter={16}>
                  <Col md={12}>
                    <Input
                      addonAfter={"บาท"}
                      value={value.trash_fee}
                      id="trash_fee"
                      onChange={changeTrashfee}
                    />
                  </Col>
                </Row>
              </StyledFee>
            </StyledCard>
            <div className="btn-layout">
              <StyledSubmitButton
                type="default"
                text={t("page.save")}
                // htmlType="submit"
                onClick={saveHouse}
              // onClick={handleSubmit}
              />
              <StyledCancelButton
                type="sub"
                text={t("page.cancel")}
                htmlType="button"
                onClick={handleClose}
              />
            </div>
          </StyledPageBody>
        ) : (
          <StyledPageBody>
            <StyledCard>
              <div className="title">
                ข้อมูลเจ้าของทะเบียนบ้านกิจการ
              </div>
              <div>
                <Row gutter={16}>
                  <Col md={12}>
                    <SharedInput
                      label="เลขที่นิติบุคคล*"
                      // descLabel={t("page._2_100_characters")}
                      name="card_no"
                      value={value.card_no}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="ชื่อกิจการ*"
                      // descLabel={t("page._2_100_characters")}
                      name="name"
                      value={value.name}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>

                </Row>
              </div>
            </StyledCard>
            <StyledCard>
              <div className="title">
                ข้อมูลที่อยู่
              </div>
              <div>
                <Row gutter={16}>
                  <Col md={12}>
                    <label className="label">
                      <span className="label-name">หมวดพื้นที่*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value.area_id}
                      onChange={areaChange}
                    >
                      {areaList.length > 0 &&
                        areaList.map((item, index) => {
                          return (
                            <Option value={item._id} key={index}>
                              {item.area_name}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="เลขที่ทะเบียนบ้าน*"
                      // descLabel={t("page._2_100_characters")}
                      name="register_no"
                      value={value.register_no}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="บ้านเลขที่*"
                      // descLabel={t("page._2_100_characters")}
                      name="house_no"
                      value={value.house_no}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="ซอย"
                      // descLabel={t("page._2_100_characters")}
                      name="soi"
                      value={value.soi}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="หมู่"
                      // descLabel={t("page._2_100_characters")}
                      name="moo"
                      value={value.moo}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col md={12}>
                    <SharedInput
                      label="ถนน"
                      // descLabel={t("page._2_100_characters")}
                      name="road"
                      value={value.road}
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col>
                  <Col xs={6} sm={6} md={12}>
                    <label className="label">
                      <span className="label-name">อำเภอ*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value?.amphur_id}
                      onChange={amphurChange}
                    >
                      {amphurList.length > 0 &&
                        amphurList.map((item, index) => {
                          return (
                            <Option value={item.amphur_id} key={index}>
                              {item.amphur_name_tha}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  <Col md={12}>
                    <label className="label">
                      <span className="label-name">ตำบล*</span>
                      <br /> <br />
                    </label>
                    <Select
                      value={value.district_id}
                      onChange={districtChange}
                    >
                      {districtList.length > 0 &&
                        districtList.map((item, index) => {
                          return (
                            <Option value={item.district_id} key={index}>
                              {item.district_name_tha}
                            </Option>
                          );
                        })
                      }
                    </Select>
                  </Col>
                  {/* <Col md={12}>
                    <SharedInput
                      label="รหัสไปรษณีย์"
                      // descLabel={t("page._2_100_characters")}
                      name="card_no"
                      onBlur={handleBlur}
                      onChange={changeField}
                      parentClassName="mb-6"
                    />
                  </Col> */}
                </Row>
              </div>

            </StyledCard>
            <StyledCard>
              <div className="title">
                จำนวนค่าขยะทั้งหมด
              </div>
              <StyledFee>
                <Row gutter={16}>
                  <Col md={12}>
                    <Input
                      addonAfter={"บาท"}
                      value={value.trash_fee}
                      id="trash_fee"
                      onChange={changeTrashfee}
                    />
                  </Col>
                </Row>
              </StyledFee>
            </StyledCard>
            <div className="btn-layout">
              <StyledSubmitButton
                type="default"
                text={t("page.save")}
                // htmlType="submit"
                onClick={editHouse}
              // onClick={handleSubmit}
              />
              <StyledCancelButton
                type="sub"
                text={t("page.cancel")}
                htmlType="button"
                onClick={handleClose}
              />
            </div>
          </StyledPageBody>
        )}
      </form>
    </div>
  );
});
const StyledAddCategoryModal = styled(Modal)`
    .ant-modal-header {
        border-bottom: 0.5px solid #8a959e !important;
        margin-bottom: 20px;
    }
    .form-input {
        .input-with-search {
            width: 100%;
        }
        .ant-select-selection__rendered {
            height: 100%;
        }
    }
    .footer {
        display: flex;
        justify-content: center;
        .add-cat-btn {
            width: 170px;
        }
    }
`;
const StyledSwitch = styled.div`
    display: flex;
    align-items: center;
    p {
        margin-bottom: 0;
    }
`;

const StyleMenuTab = styled.div`
    span {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        margin-right: 10px;
        padding: 10px;
        cursor: pointer;
    }
    .selected {
        background-color: #fff;
        border-top: 5px solid #0d6efd;
        color: #0d6efd;
        border-radius: 5px 5px 0 0;
    }
`;

const StyledBidderNum = styled.div`
    height: 30px;
    display: flex;
    .title {
        margin-left: 5px;
    }

    .number {
        font-weight: 600;
        font-size: 35px;
        line-height: 53px;
        margin-left: auto;
    }
`;

const StyledBidderList = styled.div`
    .header {
        display: flex;
        justify-content: space-between;
    }
`;

const StyledPageBody = styled.div`
    display: grid;
    /* grid-template-columns: 760px 2fr; */
    grid-gap: 15px;
`;

const StyledDetailBody = styled.div`
    background: #ffffff;
    border-radius: 4px;
    padding: 30px;
    max-width: 700px;
    .title {
        font-weight: 500;
        font-size: 25px;
        line-height: 38px;
    }
    .period {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
    }

    hr {
        border-top: 1px solid #f3f3f3;
    }

    .detail-headline {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
    }
    .detail-desc {
        font-weight: 300;
        font-size: 16px;
        line-height: 24px;
    }
`;

const StyledDocument = styled.div`
    background-color: #f4f4f4;
    border-radius: 5px;
    margin: 10px 0px;
    display: flex;
    justify-content: space-between;
    .name {
        margin: auto 30px;
        font-weight: 600;
    }
    button {
        background-color: #0d6efd;
        border: none;
        padding: 10px;
        width: 100px;
        border-radius: 5px;
        color: white;
        margin: 15px;
    }
`;

const StyledFileName = styled.p`
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
`;


const StyledFee = styled.div`
  .ant-input-wrapper {
    height: 48px;
  }
  .ant-input {
    height: 48px;
  }
`;